module.exports = __webpack_public_path__ + "media/images/icon_file-c125940acaf16cbdabec98930f479e5c.svg";